import { authService } from '../service/auth/auth-service'
import { errorUtil } from '../util/auth-error-util'
import { queryKeys } from '../util/query-keys'
import { useMutation } from '@tanstack/react-query'

type VerifyPasswordlessLoginInput = {
  email: string
  code: string
}

export const useVerifyPasswordlessLogin = (options?: {
  onError?: (error: Error) => void
}): {
  verifyPasswordlessLogin: (input: VerifyPasswordlessLoginInput) => void
  isLoading: boolean
  error: Error | null
} => {
  const {
    mutate: verifyPasswordlessLoginMutation,
    isLoading,
    error,
  } = useMutation<void, Error, VerifyPasswordlessLoginInput>(
    async (input) => {
      await authService.verifyPasswordlessLogin({
        email: input.email,
        code: input.code,
      })
    },
    {
      mutationKey: queryKeys.verifyPasswordlessLogin(),
      onError: (err) => {
        errorUtil.logError(err)
        options?.onError?.(err)
      },
    },
  )

  const verifyPasswordlessLogin = (input: VerifyPasswordlessLoginInput): void => {
    verifyPasswordlessLoginMutation(input)
  }

  return {
    verifyPasswordlessLogin,
    isLoading,
    error,
  }
}
